import type { ReactNode } from 'react'
import { AdminPageHeader } from './AdminPageHeader'

interface AdminPageLayoutProps {
  title: string
  subtitle?: string
  backLabel?: string
  onBack?: () => void
  headerAside?: ReactNode
  children: ReactNode
}

export function AdminPageLayout({
  title,
  subtitle,
  backLabel,
  onBack,
  headerAside,
  children,
}: AdminPageLayoutProps) {
  return (
    <div className='space-y-6 pb-24'>
      <AdminPageHeader
        title={title}
        subtitle={subtitle}
        backLabel={backLabel}
        onBack={onBack}
        headerAside={headerAside}
      />
      <div className='px-6 sm:px-8'>
        {children}
      </div>
    </div>
  )
}
